import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'Work Cycle Verification',
    path: '/safety-management',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'work-cycle-verification',
      allowedRoles: [...allowed.wcv.roles],
      breadcrumb: {
        label: 'work-cycle-verification.breadcrumbs.safety-management',
        route: 'safety-management',
      },
    },
    children: [
      {
        name: 'work-cycle-verification-home',
        path: 'work-cycle-verification',
        component: () =>
          import(
            '@/modules/work-cycle-verification/containers/work-cycle-verification.container.vue'
          ),
        meta: {
          breadcrumb: {
            label: 'work-cycle-verification.breadcrumbs.work-cycle-verification',
            route: 'work-cycle-verification-home-default',
          },
        },
        children: [
          {
            path: '',
            name: 'work-cycle-verification-home-default',
            component: () =>
              import(
                '@/modules/work-cycle-verification/components/work-cycle-verification-home/work-cycle-verification-home.vue'
              ),
          },
          {
            name: 'work-cycle-verification-popit-list',
            path: 'popit-list',
            meta: {
              breadcrumb: {
                label: 'work-cycle-verification.breadcrumbs.popit-list',
                route: 'work-cycle-verification-popit-list',
                parent: 'work-cycle-verification-home',
              },
            },
            component: () =>
              import('@/modules/work-cycle-verification/containers/popit-list.container.vue'),
          },
          {
            name: 'work-cycle-verification-popit-form',
            path: 'popit-form/:id?',
            meta: {
              breadcrumb: {
                label: 'work-cycle-verification.breadcrumbs.popit-form',
                route: 'work-cycle-verification-popit-form',
                parent: 'work-cycle-verification-home',
              },
            },
            component: () =>
              import('@/modules/work-cycle-verification/containers/popit-form.container.vue'),
          },
          {
            name: 'work-cycle-verification-new-plan',
            path: 'new-plan',
            meta: {
              allowedRoles: [...allowed.wcv.settings, 'wc-leader', 'wc-coordinator'],
              breadcrumb: {
                label: 'work-cycle-verification.breadcrumbs.new-plan',
                route: 'work-cycle-verification-new-plan',
                parent: 'work-cycle-verification-home',
              },
            },
            component: () =>
              import('@/modules/work-cycle-verification/containers/new-plan.container.vue'),
            children: [
              {
                name: 'work-cycle-verification-plan-evaluation',
                path: 'evaluation',
                meta: {
                  breadcrumb: {
                    label: 'work-cycle-verification.breadcrumbs.plan-evaluation',
                    route: 'work-cycle-verification-plan-evaluation',
                    parent: 'work-cycle-verification-new-plan',
                  },
                },
                component: () =>
                  import(
                    '@/modules/work-cycle-verification/containers/wcv-plan-evaluation.container.vue'
                  ),
              },
            ],
          },
          {
            name: 'work-cycle-verification-edit-plan',
            path: 'edit-plan/:id',
            meta: {
              breadcrumb: {
                label: 'work-cycle-verification.breadcrumbs.edit-plan',
                route: 'work-cycle-verification-edit-plan',
                parent: 'work-cycle-verification-home',
              },
            },
            component: () =>
              import('@/modules/work-cycle-verification/containers/new-plan.container.vue'),
            children: [
              {
                name: 'work-cycle-verification-add-plan-collaborators',
                path: 'add-plan-collaborators/:activityId',
                meta: {
                  breadcrumb: {
                    label: 'work-cycle-verification.breadcrumbs.add-collaborators',
                    route: 'work-cycle-verification-add-plan-collaborators',
                    parent: 'work-cycle-verification-edit-plan',
                  },
                },
                component: () =>
                  import(
                    '@/modules/work-cycle-verification/containers/add-collaborators.container.vue'
                  ),
              },
              {
                name: 'work-cycle-verification-verification-steps',
                path: 'verification-steps/:activityId',
                meta: {
                  breadcrumb: {
                    label: 'work-cycle-verification.breadcrumbs.verification-steps',
                    route: 'work-cycle-verification-verification-steps',
                    parent: 'work-cycle-verification-edit-plan',
                  },
                },
                component: () =>
                  import(
                    '@/modules/work-cycle-verification/containers/verification-steps.container.vue'
                  ),
              },
            ],
          },
          {
            name: 'work-cycle-verification-plan-evaluation-form',
            path: 'edit-plan/:id/activity/:activityId/evaluation/:collaboratorId',
            meta: {
              breadcrumb: {
                label: 'work-cycle-verification.breadcrumbs.collaborator-evaluation',
                route: 'work-cycle-verification-plan-evaluation-form',
                parent: 'work-cycle-verification-edit-plan',
              },
            },
            component: () =>
              import(
                '@/modules/work-cycle-verification/containers/wcv-plan-evaluation.container.vue'
              ),
            props: true,
          },
          {
            name: 'work-cycle-verification-checklist',
            path: 'checklist',
            meta: {
              breadcrumb: {
                label: 'work-cycle-verification.checklist.breadcrumb',
                route: 'work-cycle-verification-checklist',
                parent: 'work-cycle-verification-home',
              },
            },
            component: () =>
              import(
                '@/modules/work-cycle-verification/components/wcv-checklist/wcv-checklist.vue'
              ),
          },
          {
            name: 'work-cycle-verification-add-plan-checklist',
            path: 'edit-plan/:id/add-plan-checklist/:activityId',
            meta: {
              breadcrumb: {
                label: 'work-cycle-verification.breadcrumbs.add-checklist',
                route: 'work-cycle-verification-add-plan-checklist',
                parent: 'work-cycle-verification-home',
              },
            },
            component: () =>
              import(
                '@/modules/work-cycle-verification/components/wcv-checklist/wcv-checklist.vue'
              ),
          },
          {
            name: 'work-cycle-verification-results',
            path: 'edit-plan/:id/results/:activityId',
            meta: {
              breadcrumb: {
                label: 'work-cycle-verification.breadcrumbs.results',
                route: 'work-cycle-verification-results',
                parent: 'work-cycle-verification-home',
              },
            },
            component: () =>
              import('@/modules/work-cycle-verification/components/wcv-results/wcv-results.vue'),
          },
        ],
      },
    ],
  },
]

export default index
